import { BRAND } from "@/mock";

/**
 * Generate a pre-filled WhatsApp click-to-book URL.
 * @param {object} opts
 * @param {string} opts.roomName - "1 BHK Apartment", "Single Room (A/C)" etc.
 * @param {string} [opts.basis] - "Daily" or "Monthly"
 * @param {string} [opts.checkIn] - ISO date
 * @param {number} [opts.nights]
 * @returns {string} wa.me URL with encoded message
 */
export const buildWhatsAppBookingUrl = ({ roomName, basis, checkIn, nights }) => {
  const parts = [
    `Hi Hitha Residency!`,
    ``,
    roomName
      ? `I'd like to book the *${roomName}*${basis ? ` on ${basis} basis` : ""}.`
      : `I'd like to enquire about available rooms.`,
  ];
  if (checkIn) parts.push(`Check-in: ${checkIn}${nights ? ` (${nights} nights)` : ""}`);
  parts.push(``, `Please share availability and final rate. Thank you!`);
  const text = encodeURIComponent(parts.join("\n"));
  return `https://wa.me/${BRAND.whatsapp}?text=${text}`;
};
